export enum ByCustomerOrVolume {
  CUSTOMER = "CUSTOMER",
  VOLUME = "VOLUME",
}
